import axios from 'axios/index'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import consts from '../../util/consts'
import createAsyncConst from '../../util/createAsyncConst'

export const SUBMIT_CLIENT_PLAN = createAsyncConst('SUBMIT_CLIENT_PLAN')
export const FETCH_CLIENT_PLAN = createAsyncConst('FETCH_CLIENT_PLAN')
export const EDIT_CLIENT_PLAN = createAsyncConst('EDIT_CLIENT_PLAN')
export const FETCH_CEP = createAsyncConst('FETCH_CEP')

export function fetchClientPlan(page, filters = [], rows) {
  return dispatch => {
    dispatch(action(FETCH_CLIENT_PLAN.ACTION))
    return axios
      .get(`${config.API_URL}/client-plan`, {
        params: {
          filters: JSON.stringify(filters),
          rows: rows || consts.DEFAULT_PAGINATION,
          page: page || 1,
        },
      })
      .then(resp => {
        dispatch(action(FETCH_CLIENT_PLAN.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_CLIENT_PLAN, e)))
  }
}

export function edit(id) {
  return dispatch => {
    dispatch(action(EDIT_CLIENT_PLAN.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/client-plan/${id}`)
      .then(resp => {
        return resp.data.data
      })
      .then(data => dispatch(action(EDIT_CLIENT_PLAN.SUCCESS, data)))
      .catch(e => dispatch(actionFailed(EDIT_CLIENT_PLAN, e)))
  }
}

function submit(values, method) {
  const id = values.id ? `/${values.id}` : ''
  const payload = {
    ...values,
    is_active: values.is_active ? 1 : 0,
    advantages: values.advantages || [],
  }
  return dispatch => {
    dispatch(action(SUBMIT_CLIENT_PLAN.ACTION))
    return axios[method](`${config.API_URL}/client-plan${id}`, payload)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_CLIENT_PLAN.SUCCESS, data))
        dispatch(fetchClientPlan())
        return data
      })
      .catch(e => dispatch(actionFailed(SUBMIT_CLIENT_PLAN, e)))
  }
}

export function update(values) {
  return submit(values, 'put')
}
